'use client'

import React from 'react'
import { usePathname } from 'next/navigation'
import { Header } from "@/components/header"
import { Footer } from "@/components/footer"

export function LayoutWrapper({ children }: { children: React.ReactNode }) {
    const pathname = usePathname()
    const isReaderPage = pathname?.startsWith('/reader')

    return (
        <>
            {!isReaderPage && <Header />}
            <main className="flex-1 flex items-center justify-center px-4 py-8">
                {children}
            </main>
            {!isReaderPage && <Footer />}
        </>
    )
}

